import { cfInlineImage } from '../../lib/image';
import { Button, ContentRow } from '../ui';

/** VE section kept from the current home: the free parent guides funnel (/free-guides-for-parents). */
export default function GuidesRow() {
  return (
    <section className="ve-section ve-home-guides" aria-labelledby="home-guides-title">
      <div className="ve-container">
        <ContentRow
          reverse
          image={{
            src: cfInlineImage('/images/saylor-child-neck.webp'),
            alt: "Dr. Saylor gently checking a young child's neck",
            width: 425,
            height: 425,
            loading: 'lazy',
          }}
        >
          <span className="ve-eyebrow">Free guides for parents</span>
          <h2 id="home-guides-title">Practical Help for Sleep, Digestion, and Growing Kids</h2>
          <p>
            Our doctors wrote short guides for Royal Oak families on healthy sleep, digestion, and
            raising kids naturally. Read them tonight, and bring your questions to your next visit.
          </p>
          <div className="ve-btn-row">
            <Button to="/free-guides-for-parents/">Get the Free Guides</Button>
          </div>
        </ContentRow>
      </div>
    </section>
  );
}
